import React from "react";
import { cn } from "../../../common/u1/cn";

/* The white card every dashboard section sits in. */
export const SectionCard = ({
  title,
  count,
  head,
  action,
  children,
  padding = "p-5 sm:p-[26px] sm:px-[30px]",
  className = "",
  ...rest
}) => (
  <section
    className={cn(
      "rounded-[18px] border border-[var(--line)] bg-white shadow-[0_1px_2px_rgba(20,40,60,.03)]",
      padding,
      className
    )}
    {...rest}
  >
    {(title || head) && (
      <div className="mb-2 flex items-center gap-3">
        {head || (
          <>
            {/* The design's .sec-head bar — a coral rule marking the section. */}
            <span aria-hidden="true" className="h-5 w-1 shrink-0 rounded-sm bg-[var(--coral)]" />
            <h3 className="text-[19px] font-bold text-[var(--ink)] font-sans">{title}</h3>
            {count !== undefined && count !== null && <CountBadge value={count} />}
          </>
        )}
        {action && <div className="ml-auto">{action}</div>}
      </div>
    )}
    {children}
  </section>
);

/* The navy pill beside a section title. Capped so a large number cannot
   stretch the head — the exact figure is on the section's own page. */
export const CountBadge = ({ value, max = 100 }) => (
  <span className="inline-flex h-[22px] min-w-[22px] items-center justify-center rounded-[11px] bg-[var(--claimed-bg)] px-1.5 text-[12px] font-bold text-[var(--navy)] font-sans">
    {Number(value) > max ? `${max}+` : value}
  </span>
);

export default SectionCard;
